const Test = () => {

    return (
        <>
            <section className="section">
                <div className="section-container">
                    <div className="section-header">
                        <p className="eyebrow">Internal</p>
                        <h1>This is a test page, please ignore.</h1>
                        <p className="body-text">Use it as a sandbox for quick UI experiments.</p>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Test;



